import { Vector3 as w } from "three";
import { ModuleLikeTransform as C, RG_TYPE as m, roundDecimals as M } from "@project-rouge/rg-core";
import { getPivot as x } from "../../geometry-utils/three/index12.js";
const y = {
  ceiling: 0.05
};
function F(u, s) {
  if (C.includes(s.type)) {
    const O = x([0.5, 0, 0.5], u.userData), D = u.children.filter((e) => e.userData.type === m.Ceiling)[0], r = u.children.filter((e) => e.userData.type === m.Floor)[0], z = u.children.filter((e) => e.userData.type === m.Wall), g = z.map((e) => x([0.5, 0, 0.5], e.userData)), f = [], p = [];
    for (let e = 0; e < z.length; e++) {
      const A = M(new w(0, 0, 1).dot(g[e].clone().sub(O).add(u.position)), 3), W = M(new w(1, 0, 0).dot(g[e].clone().sub(O).add(u.position)), 3);
      f.push(A), p.push(W);
    }
    const i = z[f.indexOf(Math.max(...f))], t = z[f.indexOf(Math.min(...f))], a = z[p.indexOf(Math.max(...p))], o = z[p.indexOf(Math.min(...p))], n = i ? i.userData.size[2] : 0, c = t ? t.userData.size[2] : 0, l = a ? a.userData.size[2] : 0, h = o ? o.userData.size[2] : 0;
    if (s.type === m.Balcony) {
      if (r && (r.userData.pos = [r.userData.pos[0] * s.size[0] / r.userData.size[0], r.userData.pos[1], r.userData.pos[2] * s.size[2] / r.userData.size[2]], r.position.fromArray(r.userData.pos), r.userData.size = [s.size[0], r.userData.size[1], s.size[2]]), o) {
        o.userData.size = [s.size[2], s.size[1] - r.userData.size[1], o.userData.size[2]];
        const e = [o.userData.size[0] * (1 - o.userData.anchor[0]), o.userData.size[1] * o.userData.anchor[1], o.userData.size[2] * (1 - o.userData.anchor[2])];
        o.userData.pos = [r.position.x - r.userData.size[0] * 0.5 + e[2], r.position.y + r.userData.size[1] + e[1], r.position.z - r.userData.size[2] * 0.5 + e[0]], o.position.fromArray(o.userData.pos);
      }
      if (a) {
        a.userData.size = [s.size[2], s.size[1] - r.userData.size[1], a.userData.size[2]];
        const e = [a.userData.size[0] * (1 - a.userData.anchor[0]), a.userData.size[1] * a.userData.anchor[1], a.userData.size[2] * (1 - a.userData.anchor[2])];
        a.userData.pos = [r.position.x + r.userData.size[0] * 0.5 - e[2], r.position.y + r.userData.size[1] + e[1], r.position.z + r.userData.size[2] * 0.5 - e[0]], a.position.fromArray(a.userData.pos);
      }
      if (i) {
        i.userData.size = [s.size[0], s.size[1] - r.userData.size[1], i.userData.size[2]];
        const e = [i.userData.size[0] * (1 - i.userData.anchor[0]), i.userData.size[1] * i.userData.anchor[1], i.userData.size[2] * (1 - i.userData.anchor[2])];
        i.userData.pos = [r.position.x - r.userData.size[0] * 0.5 + e[0], r.position.y + r.userData.size[1] + e[1], r.position.z + r.userData.size[2] * 0.5 - e[2]], i.position.fromArray(i.userData.pos);
      }
    } else {
      if (r && (r.userData.pos = [
        r.userData.pos[0] * s.size[0] / (r.userData.size[0] + l + h),
        r.userData.pos[1],
        r.userData.pos[2] * s.size[2] / (r.userData.size[2] + n + c)
      ], r.position.fromArray(r.userData.pos), r.userData.size = [
        s.size[0] - l - h,
        r.userData.size[1],
        s.size[2] - n - c
      ]), D && (D.userData.pos = [
        D.userData.pos[0] * s.size[0] / (D.userData.size[0] + l + h),
        s.size[1],
        D.userData.pos[2] * s.size[2] / (D.userData.size[2] + n + c)
      ], D.position.fromArray(D.userData.pos), D.userData.size = [
        s.size[0] - l - h,
        D.userData.size[1],
        s.size[2] - n - c
      ]), i) {
        i.userData.size = [
          s.size[0],
          s.size[1] - y.ceiling,
          i.userData.size[2]
        ];
        const e = [i.userData.size[0] * (1 - i.userData.anchor[0]), i.userData.size[1] * i.userData.anchor[1], i.userData.size[2] * (1 - i.userData.anchor[2])];
        i.userData.pos = [
          s.size[0] * s.anchor[0] - e[0],
          s.size[1] * s.anchor[1] + e[1],
          s.size[2] * s.anchor[2] - e[2]
        ], i.position.fromArray(i.userData.pos);
      }
      if (t) {
        t.userData.size = [
          s.size[0],
          s.size[1] - y.ceiling,
          t.userData.size[2]
        ];
        const e = [t.userData.size[0] * (1 - t.userData.anchor[0]), t.userData.size[1] * t.userData.anchor[1], t.userData.size[2] * (1 - t.userData.anchor[2])];
        t.userData.pos = [
          -s.size[0] * (1 - s.anchor[0]) + e[0],
          s.size[1] * s.anchor[1] + e[1],
          -s.size[2] * (1 - s.anchor[2]) + e[2]
        ], t.position.fromArray(t.userData.pos);
      }
      if (o) {
        o.userData.size = [
          s.size[2] - n - c,
          s.size[1] - y.ceiling,
          o.userData.size[2]
        ];
        const e = [o.userData.size[0] * (1 - o.userData.anchor[0]), o.userData.size[1] * o.userData.anchor[1], o.userData.size[2] * (1 - o.userData.anchor[2])];
        o.userData.pos = [
          -s.size[0] * s.anchor[0] + e[2],
          s.size[1] * s.anchor[1] + e[1],
          -s.size[2] * s.anchor[2] + e[0] + n
        ], o.position.fromArray(o.userData.pos);
      }
      if (a) {
        a.userData.size = [
          s.size[2] - n - c,
          s.size[1] - y.ceiling,
          a.userData.size[2]
        ];
        const e = [a.userData.size[0] * (1 - a.userData.anchor[0]), a.userData.size[1] * a.userData.anchor[1], a.userData.size[2] * (1 - a.userData.anchor[2])];
        a.userData.pos = [
          s.size[0] * s.anchor[0] - e[2],
          s.size[1] * s.anchor[1] + e[1],
          s.size[2] * s.anchor[2] - e[0] - n
        ], a.position.fromArray(a.userData.pos);
      }
    }
    for (let e = 1; e < u.children.length; e++)
      u.children[e].updateGeo();
  }
  u.userData = s, u.updateGeo();
}
export {
  F as transformChildrenToParentSize
};
//# sourceMappingURL=index2.js.map
